import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

export default class LogicalCircles extends Component {
	constructor() {
		super({
			element: '.vision',
			elements: {
				circles: '.vision__logical-circles',
			},
		});
	}

	create() {
		super.createComponent();
		if (!this.elements.circles) return;

		// Orbit the 4 shapes clockwise in 90° steps about the composition center.
		// Absolute angles + a final reset to 0 keep every repeat running forward
		// instead of snapping 360→90 backwards.
		this.tl = GSAP.timeline({ repeat: -1 });

		for (let i = 1; i <= 4; i++) {
			this.tl.to(
				this.elements.circles,
				{
					rotation: i * 90,
					duration: 1,
					ease: 'power3.out',
					svgOrigin: '136 135.5',
				},
				i === 1 ? 0 : '+=0.75'
			);
		}

		this.tl.set(this.elements.circles, { rotation: 0 }, '+=0.75');
	}

	destroy() {
		this.tl?.kill();
		super.destroy();
	}
}
